'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ListItem = require('components/ListItem/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./RecipientDetailedStatsList.scss');

var RecipientDetailedStatsListItem = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(RecipientDetailedStatsListItem, _PureComponent);

  function RecipientDetailedStatsListItem() {
    (0, _classCallCheck3.default)(this, RecipientDetailedStatsListItem);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientDetailedStatsListItem.__proto__ || (0, _getPrototypeOf2.default)(RecipientDetailedStatsListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientDetailedStatsListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          data = _props.data,
          track = _props.track;


      return _react2.default.createElement(
        _ListItem2.default,
        { className: (0, _bind2.default)(styles.row, className) },
        _react2.default.createElement(
          'div',
          null,
          track.fullName
        ),
        _react2.default.createElement(
          'div',
          null,
          data.durationString
        ),
        _react2.default.createElement(
          'div',
          null,
          data.dateString
        )
      );
    }
  }]);
  return RecipientDetailedStatsListItem;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  data: _propTypes2.default.object,
  track: _propTypes2.default.object
}, _class.defaultProps = {
  data: {},
  track: {}
}, _temp);
exports.default = RecipientDetailedStatsListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/RecipientDetailedStatsList/RecipientDetailedStatsListItem.js
// module id = 2118
// module chunks = 1